import BackgroundOrbs from "./BackgroundOrbs";

const PageLayout = ({
  children,
  title = "Casting Money Drop",
  wide = false,
  hideHeader = false,
  className = "",
}) => (
  <div className={`min-h-screen bg-md-navy relative overflow-x-hidden ${className}`}>
    <BackgroundOrbs />

    {!hideHeader && (
      <header className="relative z-10 py-6 px-4 border-b border-md-cyan/10">
        <h1 className="max-w-4xl mx-auto text-center text-xl sm:text-2xl font-bold text-md-silver tracking-wide drop-shadow-[0_0_12px_rgba(79,195,247,0.4)]">
          {title}
        </h1>
      </header>
    )}

    <main className={`relative z-10 py-8 px-4 ${wide ? "" : ""}`}>
      <div className={wide ? "max-w-6xl mx-auto" : "max-w-2xl mx-auto"}>{children}</div>
    </main>
  </div>
);

export default PageLayout;
